import { ConsultaPadrao } from "../../../../components/ConsultaPadrao";
import { model_repeticao_tempo } from "../../../../models";
import { RepeticaoTempoExercicio } from "./RepeticaoTempoExercicio";
import { useRef } from "react";
import { FaPersonRunning } from 'react-icons/fa6';

export const RepeticaoTempo = () => {
    const refExercicio = useRef<any>();

    const columns = [
        { field: 'etapaid', header: 'Código' },
        { field: 'etapadescricao', header: 'Título' },
        { field: 'etapaativo', header: 'Ativo' },
        { field: 'functions', style: { minWidth: '7rem', width: '7rem' } }
    ];

    function functions(row: any) {
        return ([
            {
                label: 'Exercícios',
                click: () => refExercicio.current.openModal(row),
                icon: <FaPersonRunning size={24} />,
                color: '#0589a0'
            },
        ])
    }

    return (
        <>
            <ConsultaPadrao model={model_repeticao_tempo} columns={columns} functions={functions} />
            <RepeticaoTempoExercicio ref={refExercicio} />
        </>
    )
}